import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../domain/entities/ExceptionEntity";
import BucketEntity from "../../../domain/entities/BucketEntity";
import UserEntity from "../../../domain/entities/UserEntity";
import BucketRepository from "../../../domain/repositories/BucketRepository";
import GetAllBucketsApiImpl from "./api/impl/GetAllBucketsApiImpl";
import GetUsersInBucketApiImpl from "./api/impl/GetUsersInBucketApiImpl";
import MoveUserToBucketApiImpl from "./api/impl/MoveUserToBucketApiImpl";

@injectable()
class BucketRepositoryImpl implements BucketRepository {
    getAll = async (): Promise<Either<ExceptionEntity, BucketEntity[]>> => GetAllBucketsApiImpl();
    getUsersInBucket = async (bucketId: number, page: number, perPage: number): Promise<Either<ExceptionEntity, UserEntity[]>> => GetUsersInBucketApiImpl(bucketId, page, perPage);
    moveUserToBucket = async (userId: string, location: string, client: string, supervisor: string): Promise<Either<ExceptionEntity, string>> => MoveUserToBucketApiImpl(userId, location, client, supervisor);
}

export default BucketRepositoryImpl;
